import React, { useState, useEffect, Suspense, useRef, useMemo, useCallback } from 'react'
import classes from "./DeviceManager.module.css";
import DeviceLoadingGrid from '../GridList/DeviceLoadingGrid';
import { Await, useNavigate } from 'react-router-dom';
import UseDateFormat from '../hooks/UseDateFormat';
import GetAllPagedDevices from '../../Pages/AllSites/GetAllPagedDevices';
import { useDispatch, useSelector } from 'react-redux';
import DataManager from '../../hooks/DataManager';
import Button1 from '../UI/Button/Button1';
import { addSitesToGroup, getAllSitesAPI, getAllSitesNewAPI, getGroups, inviteUser } from '../../Api Methods/Api';
import DevicesList from '../GridList/DevicesList';
import Modal from '../../components/Modal/Modal';
import Lottie from 'lottie-react';
import successAnim from '../../assets/animations/success.json'
import failAnim from '../../assets/animations/fail.json'
import waitAnim from '../../assets/animations/pleasewait.json'
import areYouSureAnim from '../../assets/animations/areYouSure.json'
import SelectRoleForm from '../forms/SelectRoleForm';
import { Button } from 'primereact/button';
import AllSitesSearchBar from '../../Pages/AllSites/allSitesSearchBar';
import { serviceActions } from '../../store/service-Slice';
import mixpanel from 'mixpanel-browser';
import { ca } from 'date-fns/locale';
import { use } from 'react';
import Papa from 'papaparse';


const DeviceManager = ({ client, token, companyName, aiQuery, getAllDevices }) => {

    const dataManager = new DataManager();
    const [groups, setGroups] = useState([])
    const _companyName = useSelector(state => state.auth.companyName);
    const userID = useSelector(state => state.auth.userID);
    const role = useSelector(state => state.auth.role);
    const [userRole, setUserRole] = useState();
    const [showMassSettings, setShowMassSettings] = useState(false)

    const apiData = {
        token,
        client
    }

    const [groupMode, setGroupMode] = useState(dataManager.getItem('isGroupMode'));
    const addAccessMode = dataManager.getItem('isAddAccessMode')

    const ModalDialog = useRef();
    const [title, setTitle] = useState('');
    const [modalComponent, setModalComponent] = useState();

    const navigate = useNavigate();
    const dispatch = useDispatch();

    const service = useSelector(state => state.service);

    const prevBody = useRef();

    //Filters
    const [active, setActive] = useState(service.active)
    const [online, setOnline] = useState(service.online)
    const [offline, setOffline] = useState(service.offline)
    const [deviceTag, setDeviceTag] = useState(service.deviceTag)
    const [cloudController, setCloudController] = useState(service.cloudController)
    const [davantis, setDavantis] = useState(service.davantis)
    const [g2cc, setG2cc] = useState(service.g2cc)
    const [ESP, setESP] = useState(service.ESP)
    const [RPi, setRPi] = useState(service.RPi)
    const [groupName, setGroupName] = useState(service.groupName)
    const [includeSubgroups, setIncludeSubgroups] = useState(service.includeSubgroups)
    const [noTag, setNoTag] = useState(service.noTag)
    const [searchTerm, setSearchTerm] = useState(service.searchTerm)
    const [noUsers, setNoUsers] = useState(service.noUsers)
    const [liveViewStatus, setLiveViewStatus] = useState(service.liveViewStatus)
    const [scheduleOnly, setScheduleOnly] = useState(service.scheduleOnly)
    const [hasAjax, setHasAjax] = useState(service.hasAjax)
    const [hasHik, setHasHik] = useState(service.hasHik)
    const [hasAIBOX, setHasAIBOX] = useState(service.hasAIBOX)
    const [hasDahua, setHasDahua] = useState(service.hasDahua)
    const [hasPadlock, setHasPadlock] = useState(service.hasPadlock)
    const [hasKeybox, setHasKeybox] = useState(service.hasKeybox)
    const [hasGateway, setHasGateway] = useState(service.hasGateway)
    const [hasSigfox, setHasSigfox] = useState(service.hasSigfox)
    const [hasIndSigfox, setHasIndSigfox] = useState(service.hasIndSigfox)
    const [hasEfento, setHasEfento] = useState(service.hasEfento)
    const [hasTeltonika, setHasTeltonika] = useState(service.hasTeltonika)
    const [hasSchedules, setHasSchedules] = useState(service.hasSchedules)
    const [hasTempSchedules, setHasTempSchedules] = useState(service.hasTempSchedules)
    const [activePinCount, setActivePinCount] = useState(service.activePinCount)
    const [ruleV2Owner, setRuleV2Owner] = useState(service.ruleV2Owner)
    const [ruleV2Parent, setRuleV2Parent] = useState(service.ruleV2Parent)
    const [ruleV2Affected, setRuleV2Affected] = useState(service.ruleV2Affected)
    const [connectionIssues, setConnectionIssues] = useState(service.connectionIssues)
    const [hasCamerasLinked, setHasCamerasLinked] = useState(service.hasCamerasLinked)
    const [billable, setBillable] = useState(service.billable)
    const [billingFrequency, setBillingFrequency] = useState(service.billingFrequency)
    const [billedTo, setBilledTo] = useState(service.billedTo)

    useEffect(() => {
        dispatch(serviceActions.setSearchTerm(searchTerm))
    }, [searchTerm])

    //Sorts
    const [sortAsc, setSortAsc] = useState(service.sortAsc) //descending
    const [sUserCount, setSUserCount] = useState(service.sUserCount)
    const [sCreated, setSCreated] = useState(service.sCreated) //active by default
    const [sFirmware, setSFirmware] = useState(service.sFirmware)
    const [sName, setSName] = useState(service.sName)
    const [sCameraCount, setSCameraCount] = useState(service.sCameraCount)
    const [sDateOfSale, setSDateOfSale] = useState(service.sDateOfSale)
    const [sLastInvoice, setSLastInvoice] = useState(service.sLastInvoice)
    const [sDateMadeActive, setSDateMadeActive] = useState(service.sDateMadeActive)

    const [totalPages, setTotalPages] = useState([])
    const [resultCount, setResultCount] = useState(0)
    const [totalDevices, setTotalDevices] = useState([])
    // const [pageOffset, setPageOffset] = useState(0)
    const [pageFetchedIndex, setPageFetchedIndex] = useState(1)
    const [pageSize, setPageSize] = useState(dataManager.getItem('sitesPageSize'))
    const [update, setUpdate] = useState(0)
    const [submit, setSubmit] = useState(0)

    const [dataToExport, setDataToExport] = useState([]);

    const cached = useSelector(state => state.service.AllSitesTableData);
    const cachedSignature = cached?.request
        ? JSON.stringify(cached.request)
        : null;

    
    const [isInitialLoading, setIsInitialLoading] = useState(true);
    const [isBackgroundFetching, setIsBackgroundFetching] = useState(false);

    const useDebounce = (value, delay = 700) => {
        const [debounced, setDebounced] = useState(value);
      
        useEffect(() => {
          const t = setTimeout(() => setDebounced(value), delay);
          return () => clearTimeout(t);
        }, [value, delay]);
      
        return debounced;
    };

    const debouncedSearchTerm = useDebounce(searchTerm, 700);


    const HandleShowModal = () => {
        ModalDialog.current.open();
    };

    const HandleCloseModal = () => {
        ModalDialog.current.close();
    };

    useEffect(() => {
        mixpanel.track("All sites tab visited", {
            user: localStorage.getItem('email')
        });
    }, []);

    const GetGroups = async () => {
        try {
            const listOptions = await getGroups(apiData, dispatch);
            setGroups(listOptions || []);
        } catch (error) {
            console.error('Failed to fetch groups:', error);
            setGroups([]);
        }
    }

    useEffect(() => {
        GetGroups();
    }, [])
    
    const pageOffset = useMemo(
        () => pageSize * (pageFetchedIndex - 1),
        [pageSize, pageFetchedIndex]
    );
      
    const requestBody = useMemo(() => ({
        active: Number(active),
        pageSize: Number(pageSize),
        pageOffset,
        online: Number(online),
        offline: Number(offline),
        deviceTag,
        cloudController: Number(cloudController),
        davantis: Number(davantis),
        g2cc: Number(g2cc),
        ESP: Number(ESP),
        RPi: Number(RPi),
        groupName,
        includeSubgroups: Number(includeSubgroups),
        noTag: Number(noTag),
        searchTerm: debouncedSearchTerm,
        noUsers: Number(noUsers),
        liveViewStatus: Number(liveViewStatus),
        scheduleOnly: Number(scheduleOnly),
        hasAjax: Number(hasAjax),
        hasHik: Number(hasHik),
        hasAIBOX: Number(hasAIBOX),
        hasDahua: Number(hasDahua),
        hasPadlock: Number(hasPadlock),
        hasKeybox: Number(hasKeybox),
        hasGateway: Number(hasGateway),
        hasSigfox: Number(hasSigfox),
        hasIndSigfox: Number(hasIndSigfox),
        hasEfento: Number(hasEfento),
        hasTeltonika: Number(hasTeltonika),
        hasSchedules: Number(hasSchedules),
        hasTempSchedules: Number(hasTempSchedules),
        activePinCount: Number(activePinCount),
        sortAsc: Number(sortAsc),
        sUserCount: Number(sUserCount),
        sCreated: Number(sCreated),
        sFirmware: Number(sFirmware),
        sName: Number(sName),
        sCameraCount: Number(sCameraCount),
        ruleV2Owner: Number(ruleV2Owner),
        ruleV2Parent: Number(ruleV2Parent),
        ruleV2Affected: Number(ruleV2Affected),
        connectionIssues: Number(connectionIssues),
        hasCamerasLinked: Number(hasCamerasLinked),
        billable: Number(billable),
        billingFrequency:  Number(billingFrequency),
        billedTo: Number(billedTo),
        sDateOfSale: Number(sDateOfSale),
        sLastInvoice: Number(sLastInvoice),
        sDateMadeActive: Number(sDateMadeActive)
    }), [
        active,
        pageSize,
        pageOffset,
        online,
        offline,
        deviceTag,
        cloudController,
        davantis,
        g2cc,
        ESP,
        RPi,
        groupName,
        includeSubgroups,
        noTag,
        debouncedSearchTerm,
        noUsers,
        liveViewStatus,
        scheduleOnly,
        hasAjax,
        hasHik,
        hasAIBOX,
        hasDahua,
        hasPadlock,
        hasKeybox,
        hasGateway,
        hasSigfox,
        hasIndSigfox,
        hasEfento,
        hasTeltonika,
        hasSchedules,
        hasTempSchedules,
        activePinCount,
        sortAsc,
        sUserCount,
        sCreated,
        sFirmware,
        sName,
        sCameraCount,
        ruleV2Owner,
        ruleV2Parent,
        ruleV2Affected,
        connectionIssues,
        hasCamerasLinked,
        billable, 
        billingFrequency, 
        billedTo, 
        sDateOfSale,
        sLastInvoice, 
        sDateMadeActive
    ]);


    const requestSignature = useMemo(
        () => JSON.stringify(requestBody),
        [requestBody]
    );

    useEffect(() => {
        if (prevBody.current && prevBody.current !== requestSignature) {
            mixpanel.track("All sites search performed", {
                user: localStorage.getItem('email'),
                body: requestBody
            });
        }
        prevBody.current = requestSignature;
    }, [requestSignature]);


    const cacheMatchesRequest = cachedSignature === requestSignature;
    const hasValidCache = cacheMatchesRequest && cached?.data?.length > 0;

    const fetchSites = useCallback(async () => {
        const isColdLoad = !hasValidCache;
    
        if (isColdLoad) {
            setIsInitialLoading(true);
        } else {
            setIsBackgroundFetching(true);
        }
    
        try {
            console.log(requestBody);
            const response = await getAllSitesNewAPI(apiData, requestBody, dispatch);
    
            const total = response.data[0][0].totalCount;
            const sites = response.data[1];
            const totalPages = Math.ceil(total / pageSize);
    
            dispatch(serviceActions.setAllSitesTableData({
                data: sites,
                request: requestBody
            }));
    
            setResultCount(total);
            setTotalPages(totalPages);
        } catch (err) {
            console.error('Fetch failed', err);
        } finally {
            setIsInitialLoading(false);
            setIsBackgroundFetching(false);
        }
    }, [requestBody, pageSize, hasValidCache]);
    
    
      useEffect(() => {
        fetchSites();
      }, [
        fetchSites,
        submit 
      ]);

    const showError = (response) => {
        setTitle("Error")
        setModalComponent(
            <div>
                <div>
                    <h3 style={{ textAlign: "center" }}>Error</h3>
                </div>
                <div>
                    <p style={{ textAlign: "center" }}>{response.msg}</p>
                </div>
                <div style={{
                    display: "flex",
                    flexDirection: "column",
                    alignItems: "center",
                    gap: "10px" // Adds space between buttons
                }}>
                    <Button icon="pi pi-times" onClick={HandleCloseModal} label='Close' severity='secondary'/>
                </div>
            </div>
        )

        HandleShowModal();
    }

    const navigateToGroup = () => {
        HandleCloseModal();
        navigate('/Dashboard/Groups/GroupSites')
    }

    const successModal = () => {
        setTitle('Success')
        setModalComponent(
            <div style={{ display: "flex", flexDirection: "column", alignItems: "center", justifyContent: "center" }}>
                <Lottie animationData={successAnim} loop={false} style={{ width: 250, height: 250, margin: "0px" }} />
                <h3 style={{ textAlign: "center", color: "#6e6e6eff" }}>Action completed successfully</h3>
                <br />
                <Button icon="pi pi-chevron-right"  onClick={navigateToGroup} label='Take me there' severity='secondary'/>
            </div>
        )

        HandleShowModal();
    }

     const exportDownloadSuccess = () => {
        setTitle('Success')
        setModalComponent(
            <div style={{ display: "flex", flexDirection: "column", alignItems: "center", justifyContent: "center" }}>
                <Lottie animationData={successAnim} loop={false} style={{ width: 250, height: 250, margin: "0px" }} />
                <h3 style={{ textAlign: "center", color: "#6e6e6eff" }}>Data downloaded successfully!</h3>
                <br />
                <Button icon="pi pi-check"  onClick={HandleDownload} label='Get CSV' severity='success'/>
                <br/>
                <Button icon="pi pi-times"  onClick={HandleCloseModal} label='Cancel & close' severity='secondary'/>
            </div>
        )

        HandleShowModal();
    }

    const successModalAddUsers = (message) => {
        setTitle('Success')
        setModalComponent(
            <div style={{ display: "flex", flexDirection: "column", alignItems: "center", justifyContent: "center" }}>
                <Lottie animationData={successAnim} loop={false} style={{ width: 250, height: 250, margin: "0px" }} />
                <h3 style={{ textAlign: "center", color: "#6e6e6eff" }}>{message}</h3>
                <br />
                <Button icon="pi pi-times"  onClick={cancelAddAccess} severity="secondary" label="Close"/>
            </div>
        )

        HandleShowModal();
    }

    const showLoadingModal = () => {
        setTitle('Please wait...')
        setModalComponent(
            <div style={{ display: "flex", flexDirection: "column", alignItems: "center", justifyContent: "center" }}>
                <Lottie animationData={waitAnim} loop={true} style={{ width: 150, height: 150, margin: "0px" }} />
                <h3 style={{ textAlign: "center", color: "#6e6e6eff" }}>{"Adding user to selected sites..."}</h3>
            </div>
        )
        HandleShowModal();
    }

    const showExportLoadingModal = () => {
        setTitle('Please wait...')
        setModalComponent(
            <div style={{ display: "flex", flexDirection: "column", alignItems: "center", justifyContent: "center" }}>
                <Lottie animationData={waitAnim} loop={true} style={{ width: 150, height: 150, margin: "0px" }} />
                <h3 style={{ textAlign: "center", color: "#6e6e6eff" }}>{"Downloading requested data..."}</h3>
            </div>
        )
        HandleShowModal();
    }

    const AddSitesToGroup = async () => {
        let body = {
            groupID: sessionStorage.getItem('groupClickedID'),
            groupName: sessionStorage.getItem('groupClicked'),
            groupDevices: dataManager.getItem('selectedSites'),
        }
    

        const response = await addSitesToGroup(apiData, body, dispatch);

        if (response) {
            successModal();
            dataManager.setItem('isGroupMode', false);
            dataManager.setSelectedSites([]);
            setGroupMode(false);
        } else {
            //error
            showError(response.msg)
        }
    }

    const chooseRole = () => {
        setTitle("Choose role")
        setModalComponent(
            <div style={{ display: "flex", flexDirection: "column", alignItems: "center", justifyContent: "center" }}>
                <h3>Choose a role for this user</h3>
                <p>Please note, this role will apply to ALL selected sites</p>
                <small>You can change this role later using the 'Change Role' feature available in the user sites dropdown menu</small>
                <br></br>
                <SelectRoleForm
                    setUserRole={setUserRole}
                    HandleCloseModal={HandleCloseModal}
                    HandleShowLoadingModal={showLoadingModal}
                    HandleAddUserSites={addSiteAccessForUser} />
                <Button icon="pi pi-times" severity="secondary" onClick={HandleCloseModal} label='Cancel'/>
            </div>
        )
        HandleShowModal();
    }

    const addSiteAccessForUser = async () => {
        const sitesToAdd = dataManager.getItem('selectedSites')
        if (sitesToAdd.length > 0) {
            let allSuccessful = true;
            let criticalError = false;
            let alreadyExists = false;
            let sitesUserWasAlreadyOn = []

            for (const site of sitesToAdd) {
                const { deviceID, deviceName } = site;
                const userToAddID = dataManager.getItem('clickedUserID');
                const role = dataManager.getItem('roleSelectedForUserInvite');
                const emailAddress = dataManager.getItem('clickedUserEmailAddress');

                const response = await inviteUser(apiData, deviceID, userID, role, emailAddress, deviceName, _companyName, dispatch);
                if (!response.success) {
                    allSuccessful = false;
                    if (response.msg === "Relationship already exists") {
                        sitesUserWasAlreadyOn.push(deviceID)
                        alreadyExists = true
                    } else {
                        errorModal("Something went wrong, please try again.");
                        criticalError = true
                        break;
                    }
                }
            }

            // If all were successful, show success and reset data
            if (allSuccessful) {
                HandleCloseModal();
                dataManager.setItem('addAccessMode', false)
                successModalAddUsers(`Successfully added to ${sitesToAdd.length} site(s)`);
                dataManager.setSelectedSites([]);
            } else if (!criticalError && alreadyExists) {
                HandleCloseModal();
                dataManager.setItem('addAccessMode', false)
                successModalAddUsers(`Successfully added to ${sitesToAdd.length - sitesUserWasAlreadyOn.length} site(s). \nUser already had access to ${sitesUserWasAlreadyOn.length} of the selected sites`);
                dataManager.setSelectedSites([]);
            } else if (criticalError) {
                errorModal("Something went wrong, please try again");
                dataManager.setSelectedSites([]);
                dataManager.setItem('addAccessMode', false)
            }
        } else {
            errorModal("Please select a site");
        }
    }

    const showExportConfirmation = () => {
        setTitle('Are you sure?')
        setModalComponent(
            <div style={{ display: "flex", flexDirection: "column", alignItems: "center", justifyContent: "center" }}>
                <Lottie animationData={areYouSureAnim} loop={false} style={{ width: 150, height: 150, margin: "0px" }} />
                <br/>
                <h3 style={{ color: "#6e6e6eff" }}>Export {resultCount} site{resultCount !== 1 ? 's' : ''} to CSV?</h3>
                <br />
                <Button icon="pi pi-times" label="No, cancel" severity="secondary" onClick={HandleCloseModal} />
                <br />
                <Button icon="pi pi-file-export" label="Yes, export" severity="success" onClick={() => { HandleCloseModal(); HandleExport(); }} />
            </div>
        )
        HandleShowModal();
    }

    const HandleExport = async () => {
        showExportLoadingModal()
        const requestBodyForExport = {
            active: Number(active),
            pageSize: 10000000,
            pageOffset: 0,
            online: Number(online),
            offline: Number(offline),
            deviceTag,
            cloudController: Number(cloudController),
            davantis: Number(davantis),
            g2cc: Number(g2cc),
            ESP: Number(ESP),
            RPi: Number(RPi),
            groupName,
            includeSubgroups: Number(includeSubgroups),
            noTag: Number(noTag),
            searchTerm: debouncedSearchTerm,
            noUsers: Number(noUsers),
            liveViewStatus: Number(liveViewStatus),
            scheduleOnly: Number(scheduleOnly),
            hasAjax: Number(hasAjax),
            hasHik: Number(hasHik),
            hasAIBOX: Number(hasAIBOX),
            hasDahua: Number(hasDahua),
            hasPadlock: Number(hasPadlock),
            hasKeybox: Number(hasKeybox),
            hasGateway: Number(hasGateway),
            hasSigfox: Number(hasSigfox),
            hasIndSigfox: Number(hasIndSigfox),
            hasEfento: Number(hasEfento),
            hasTeltonika: Number(hasTeltonika),
            hasSchedules: Number(hasSchedules),
            hasTempSchedules: Number(hasTempSchedules),
            activePinCount: Number(activePinCount),
            sortAsc: Number(sortAsc),
            sUserCount: Number(sUserCount),
            sCreated: Number(sCreated),
            sFirmware: Number(sFirmware),
            sName: Number(sName),
            sCameraCount: Number(sCameraCount),
            ruleV2Owner: Number(ruleV2Owner),
            ruleV2Parent: Number(ruleV2Parent),
            ruleV2Affected: Number(ruleV2Affected),
            connectionIssues: Number(connectionIssues),
            hasCamerasLinked: Number(hasCamerasLinked),
            billable: Number(billable),
            billedTo: Number(billedTo),
            billingFrequency: Number(billingFrequency),
            sDateOfSale: Number(sDateOfSale),
            sLastInvoice: Number(sLastInvoice),
            sDateMadeActive: Number(sDateMadeActive)
        }
        const response = await getAllSitesAPI(apiData, requestBodyForExport, dispatch);
        if (response.success){
            HandleCloseModal()
            console.log(response.data[1]);
            console.log(filterDataForExport(response.data[1]));
            // setDataToExport(filterDataForExport(response.data[1]))
            //exportDownloadSuccess()
            const csv = Papa.unparse(filterDataForExport(response.data[1]));
            const blob = new Blob([csv], { type: 'text/csv;charset=utf-8;' });
            const link = document.createElement('a');
            const url = URL.createObjectURL(blob);

            link.href = url;
            link.setAttribute('download', 'devices.csv');

            document.body.appendChild(link);
            link.click();
            document.body.removeChild(link);
        } else {
            errorModal("Failed to retreive requested data, please try again later.")
        }
    }

    const filterDataForExport = (devices) => {
        return devices.map(device => ({
            SiteID: device.key,
            PortalName: device.tag,
            IP: converIPAddress(device.ip),
            Status: device.status,
            Users: device.userCount,
            Online: device.online,
            Firmware: device.firmware,
            Active: device.active == 1,
            Owner: device.name,
            Cameras: device.cameraCount, 
            ConnectedDevices: device.connectedDevices
        }));
    }

    const converIPAddress = (ipAddress) => {
        return 
    }
    
    const HandleDownload = () => {
        console.log(dataToExport);
        const csv = Papa.unparse(dataToExport);

        const blob = new Blob([csv], { type: 'text/csv;charset=utf-8;' });

        const link = document.createElement('a');
        const url = URL.createObjectURL(blob);

        link.href = url;
        link.setAttribute('download', 'devices.csv');

        document.body.appendChild(link);
        link.click();
        document.body.removeChild(link);
    }

    const errorModal = (message) => {
        setTitle('Error')
        setModalComponent(
            <div style={{ display: "flex", flexDirection: "column", alignItems: "center", justifyContent: "center" }}>
                <Lottie animationData={failAnim} loop={false} style={{ width: 150, height: 150, margin: "0px" }} />
                <h3 style={{ textAlign: "center", color: "#6e6e6eff" }}>{message}</h3>
                <br />
                <Button icon="pi pi-times" severity="secondary" onClick={HandleCloseModal} label="Close"/>
            </div>
        )
        HandleShowModal();
    }

    const cancel = () => {
        setGroupMode(false);
        dataManager.setItem('isGroupMode', false);
        dataManager.setSelectedSites([]);
        navigate('/Dashboard/Groups/GroupSites')
    }

    const cancelAddAccess = () => {
        dataManager.setItem('isAddAccessMode', false)
        dataManager.setSelectedSites([]);
        navigate('/Dashboard/Users/UserSites')
    }

    const sitesToRender = hasValidCache ? cached.data : [];

    return (
        <>
            <Modal ref={ModalDialog} title={title} modalName={""} HandleShowModal={HandleShowModal}>
                {modalComponent}
            </Modal>

            <div className={classes.DeviceManagerPage}>
                <div className={classes.searchContainer}>

                    <AllSitesSearchBar
                        type="text"
                        placeholder="Search..."
                        value={searchTerm}
                        onChange={(e) => setSearchTerm(e.target.value)}
                        showFilterButton={true}
                        groups={groups}
                        includeSubgroups={includeSubgroups}
                        setIncludeSubgroups={setIncludeSubgroups}
                        online={online}
                        setOnline={setOnline}
                        offline={offline}
                        setOffline={setOffline}
                        deviceTag={deviceTag}
                        setDeviceTag={setDeviceTag}
                        cloudController={cloudController}
                        setCloudController={setCloudController}
                        davantis={davantis}
                        setDavantis={setDavantis}
                        G2CC={g2cc}
                        setG2CC={setG2cc}
                        ESP={ESP}
                        setESP={setESP}
                        RPi={RPi}
                        setRPi={setRPi}
                        groupName={groupName}
                        setGroupName={setGroupName}
                        submit={submit}
                        setSubmit={setSubmit}
                        noTag={noTag}
                        setNoTag={setNoTag}
                        noUsers={noUsers}
                        setNoUsers={setNoUsers}
                        liveViewStatus={liveViewStatus}
                        setLiveViewStatus={setLiveViewStatus}
                        scheduleOnly={scheduleOnly}
                        setScheduleOnly={setScheduleOnly}
                        hasAjax={hasAjax}
                        setHasAjax={setHasAjax}
                        hasHik={hasHik}
                        setHasHik={setHasHik}
                        hasAIBOX={hasAIBOX}
                        setHasAIBOX={setHasAIBOX}
                        hasDahua={hasDahua}
                        setHasDahua={setHasDahua}
                        active={active}
                        setActive={setActive}
                        hasPadlock={hasPadlock}
                        setHasPadlock={setHasPadlock}
                        hasKeybox={hasKeybox}
                        setHasKeybox={setHasKeybox}
                        hasGateway={hasGateway}
                        setHasGateway={setHasGateway}
                        hasSigfox={hasSigfox}
                        setHasSigfox={setHasSigfox}
                        hasIndSigfox={hasIndSigfox}
                        setHasIndSigfox={setHasIndSigfox}
                        hasEfento={hasEfento}
                        setHasEfento={setHasEfento}
                        hasTeltonika={hasTeltonika}
                        setHasTeltonika={setHasTeltonika}
                        hasSchedule={hasSchedules}
                        setHasSchedule={setHasSchedules}
                        hasTempSchedules={hasTempSchedules}
                        setHasTempSchedules={setHasTempSchedules}
                        activePinCount={activePinCount}
                        setActivePinCount={setActivePinCount}
                        sortAsc={sortAsc}
                        setSortAsc={setSortAsc}
                        sUserCount={sUserCount}
                        setSUserCount={setSUserCount}
                        sCreated={sCreated}
                        setSCreated={setSCreated}
                        sFirmware={sFirmware}
                        setSFirmware={setSFirmware}
                        sName={sName}
                        setSName={setSName}
                        sCameraCount={sCameraCount}
                        setSCameraCount={setSCameraCount}
                        ruleV2Owner={ruleV2Owner}
                        setRuleV2Owner={setRuleV2Owner}
                        ruleV2Parent={ruleV2Parent}
                        setRuleV2Parent={setRuleV2Parent}
                        ruleV2Affected={ruleV2Affected}
                        setRuleV2Affected={setRuleV2Affected}
                        connectionIssues={connectionIssues}
                        setConnectionIssues={setConnectionIssues}
                        hasCamerasLinked={hasCamerasLinked}
                        setHasCamerasLinked={setHasCamerasLinked}
                        billable={billable}
                        setBillable={setBillable}
                        billedTo={billedTo}
                        setBilledTo={setBilledTo}
                        billingFrequency={billingFrequency}
                        setBillingFrequency={setBillingFrequency}
                        sDateOfSale={sDateOfSale}
                        setSDateOfSale={setSDateOfSale}
                        sLastInvoice={sLastInvoice}
                        setSLastInvoice={setSLastInvoice}
                        sDateMadeActive={sDateMadeActive}
                        setSDateMadeActive={setSDateMadeActive}
                        isInitialLoading={isInitialLoading}
                        setIsInitialLoading={setIsInitialLoading}
                        style={{
                            padding: "10px", 
                            width: "300px",    
                            fontSize: "14px",  
                            boxSizing: "border-box", 
                            borderRadius: "4px",
                        }}
                    />

                    {(role === "admin" || role === "TechSupport") && <Button className={classes.headerButton} icon="pi pi-file-export" onClick={showExportConfirmation} label='Excel export' disabled={isInitialLoading}/>}
                </div>

                <div className={classes.buttonContainer}>
                    {groupMode && <Button severity='success' style={{ fontSize: "14px", marginTop: "10px", padding:10 }} onClick={AddSitesToGroup} icon="pi pi-plus" label={`Add selected sites to ${sessionStorage.getItem('groupClicked')}`}/>}
                    {groupMode && <Button severity="danger" style={{ fontSize: "14px", marginTop: "10px", padding:10 }} onClick={cancel} icon="pi pi-times"label='Cancel' />}
                    {addAccessMode && <Button severity='success' style={{ fontSize: "14px", marginTop: "10px", padding:10 }} onClick={chooseRole}  icon="pi pi-plus" label='Add selected sites' />}
                    {addAccessMode && <Button severity='danger' style={{ fontSize: "14px", marginTop: "10px", padding:10 }} onClick={cancelAddAccess}  icon="pi pi-times" label='Cancel' />}

                </div>

                <div style={{ display: "flex", width: "100%", alignItems: "center" }}>
                    {isBackgroundFetching && (
                            <p>Updating…</p>
                        ) || <p>Total results: {resultCount}</p>
                    }  
                </div>

                
                <div style={{ display: "flex", width: "100%", height: "100%" }}>
                    {isInitialLoading && !hasValidCache ? (
                        <DeviceLoadingGrid CardCount={20} />
                    ) : (
                        <DevicesList
                            devices={sitesToRender}
                            filtering=""
                            hideControls={false}
                            totalPages={totalPages}
                            setTotalPages={setTotalPages}
                            pageFetchedIndex={pageFetchedIndex}
                            setPageFetchedIndex={setPageFetchedIndex}
                            pageSize={pageSize}
                            setPageSize={setPageSize}
                            totalDevices={resultCount}
                            setTotalDevices={setTotalDevices}
                            groupMode={groupMode}
                            update={update}
                            setUpdate={setUpdate}
                            offlineOnly={false}
                            isSortable={true}
                            showMassSelect={true}
                            showMassSettings={showMassSettings}
                            setShowMassSettings={setShowMassSettings}
                        />
                    )}
                </div>

            </div>
        </>
    )
}

export default DeviceManager